<template>
  <div id="quote-summary" class="tw-w-full tw-px-2 md:tw-px-10 tw-mt-12 tw-mb-6">
    <div class="tw-w-full" v-if="isLoading">
      <v-card
          v-if="comprehensive !== undefined && comprehensive.car.valueOfCar >= 500000"
          id="comprehensive"
          class="mx-auto md:tw-py-6 tw-bg-no-repeat tw-bg-right-bottom tw-bg-center"
          outlined
      >
        <div class="tw-w-full tw-flex-wrap tw-flex">
          <div class="tw-w-full md:tw-w-7/12 tw-px-2 md:tw-px-8 tw-py-4 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400">
            <div class="tw-flex tw-flex-wrap">
              <v-icon color="primary1" size="60" alt="car">mdi-car-outline</v-icon>
              <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center">
                <h3 class="c-blue-text title-font tw-text-base md:tw-text-2xl tw-px-3">Comprehensive Insurance Cover</h3>
              </div>
            </div>

            <v-expansion-panels v-model="panel" :multiple="true" :flat="true" class="tw-mt-5 md:tw-mt-8" accordion>
              <v-expansion-panel :readonly="true" class="tw-mt-2">
                <v-expansion-panel-header :hide-actions="true" class="tw-mt-5 tw-text-white rounded-lg" color="primary">Additional Benefits</v-expansion-panel-header>
                <v-expansion-panel-content class="tw-mt-5">
                  <p class="c-blue-text tw-text-base md:tw-text-xl">Click the check boxes below to select additional benefits at a slightly extra cost</p>
                  <div>
                    <benefits-description />
                  </div>
                  <div class="tw-w-full tw-flex tw-flex-wrap tw-mt-5">
                    <div class="tw-w-full tw-flex tw-grid tw-grid-cols-1
                 md:tw-grid-cols-2 tw-pb-4">
                      <div class="tw-w-full tw-flex tw-mt-4" v-for="(benefit, $index) in compBenefits.benefits" :key="$index">
                        <label class="tw-flex tw-items-center" :for="'check-'+$index">
                          <input :id="'check-'+$index" type="checkbox" class="filled-in text-primary primary" v-model="addBenefits" :value="{noOfBeneficiaries: 0, sectionCode: benefit.sectCode, sectionName: benefit.sectDesc}" :key="benefit.sectCode" :checked="false" :disabled="updatingAmount || selectedOther(benefit.sectCode)" />
                          <ul>
                            <li>{{ benefit.sectDesc }}</li>
                            <li class="tw-mt-1"><span class="c-blue-text"> Additional Ksh {{benefit.rateType === 'Amount' ?  benefit.rate : benefitsInAmount(benefit, comprehensive.car.valueOfCar) | formatNum }}</span></li>
                            <transition name="slide">
                              <li v-if="benefit.sectCode === 234 && isTravelEmbed" :key="'benefit'+$index">
                                <p class="tw-text-xs tw-w-full">How many people would you cover?</p>
                                <v-text-field
                                    v-model="beneficiaries"
                                    ref="beneficiaries"
                                    id="benefits"
                                    label="Add Beneficiaries (max 6)"
                                    type="number"
                                    :rules="[required('Beneficiaries'), min('Beneficiaries',benefit.minBeneficiary || travelEmbedMin), max('Beneficiaries', benefit.maxBeneficiary || travelEmbedMax)]"
                                    :disabled="updatingAmount"
                                ></v-text-field>
                              </li>
                            </transition>
                          </ul>
                        </label>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel class="tw-mt-8">
                <v-expansion-panel-header color="primary1" class="tw-text-white">Benefits Included in Your Cover
                  <template v-slot:actions>
                    <v-icon color="#fff">$expand</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="tw-w-full tw-mt-3 md:tw-mt-5">
                  <benefits />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <div class="tw-w-full tw-mt-5">
                <what-is-comprehensive />
              </div>
            </v-expansion-panels>
          </div>
          <div class="tw-w-full md:tw-w-5/12 tw-px-2 md:tw-px-8 tw-py-4 tw-flex tw-flex-wrap tw-content-between ">
            <div class="tw-w-full tw-flex tw-flex-wrap">
              <h3 class="c-blue-text title-font tw-text-xl md:tw-text-2xl tw-px-3">Premium Calculator</h3>
              <div class="tw-w-full tw-mt-5 md:tw-mt-12">
                <div class="tw-w-full tw-flex">
                  <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Basic premium</p>
                  <p class="c-gray-text tw-text-left">Ksh. {{ basicPremium(comprehensive)  | formatNum }}</p>
                </div>
                <div v-if="benefits.length > 0" class="tw-my-3 lg:tw-my-5">
                  <p style="margin-bottom: 0px;">Additional Benefits</p>
                  <div v-for="(benefit, $i) in benefits" :key="$i" class="tw-w-full tw-flex tw-items-center tw-mt-1">
                    <p class="c-blue-text tw-w-7/12 md:tw-w-8/12 tw-pr-0 lg:tw-pr-3 tw-capitalize">{{ benefit.sectDesc.toLowerCase() }}</p>
                    <p class="c-gray-text">Ksh. {{ benefit.benefitPremium | formatNum}}</p>
                  </div>
                </div>
                <div class="tw-w-full tw-flex tw-mt-3">
                  <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Levies</p>
                  <p class="c-gray-text"> Ksh. {{ levy(basicPremium(comprehensive) + sumBenefits()) + pchf(basicPremium(comprehensive) + sumBenefits()) + 40 | formatNum }}</p>
                </div>
              </div>
            </div>
            <div class="tw-w-full">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Annual Premium</h4>
              <h2 v-if="!updatingAmount" class="c-light-blue-text title-font tw-text-3xl md:tw-text-5xl">Ksh. {{ compAmount | formatNum }}</h2>
              <v-progress-circular
                  v-else
                  indeterminate
                  color="primary"
                  class="tw-mt-3"
              ></v-progress-circular>
              <v-card-actions class="tw-w-1/2 tw-mt-2">
                <v-btn block large
                       id="buyComp"
                       color="secondary"
                       class="my-3 "
                       @click="buyComprehensive"
                >
                  Buy Now
                </v-btn>
              </v-card-actions>
              <div v-if="emailQuote" class="tw-w-full tw-flex tw-justify-end">
                <email-quotation :quote-id="quote.quote.quoteId" :cover-type-id="101" />
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <div v-else class="mx-auto md:tw-py-4 tw-bg-no-repeat tw-bg-right-bottom tw-bg-center tw-bg-orange-200 tw-px-4 tw-rounded-lg c-gray-text">
        <p v-if="(new Date().getFullYear() - parseInt(thirdParty.car.yearOfManufacture, 10)) > 12">
          Your car year of manufacture <strong>{{ thirdParty.car.yearOfManufacture }}</strong> is older than required year for Comprehensive cover. You can however purchase our Third party cover as below
        </p>
        <p v-else>Your car value is less than <strong>KES 500,000</strong> required for Comprehensive cover. You can however purchase our Third party cover as below</p>
      </div>

     <v-card
         id="thirdParty"
         class="mx-auto md:tw-py-6 tw-bg-no-repeat tw-bg-right-bottom tw-bg-center tw-mt-5 md:tw-mt-12"
         outlined
         style="background-image: url(/images/icons/car-gray.png);"
     >
        <div class="tw-w-full tw-flex-wrap tw-flex">
          <div class="tw-w-full md:tw-w-7/12 tw-px-2 md:tw-px-8 tw-py-4 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400 tw-flex tw-flex-wrap tw-content-between">
            <div class="tw-w-full">
              <div class="tw-flex tw-flex-wrap">
              <v-icon color="primary1" size="60" alt="car">mdi-car-outline</v-icon>
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center">
                  <h3 class="c-blue-text title-font tw-text-base md:tw-text-2xl tw-px-3">Third Party Only <br> Insurance Cover</h3>
                  <v-chip
                      v-if="thirdParty.recommended || (comprehensive !== undefined && comprehensive.car.valueOfCar < 500000)"
                      class="ma-1 tw-mt-2 md:tw-mt-0"
                      color="green"
                      text-color="white"
                  >
                    Recommended
                  </v-chip>
                </div>
              </div>

              <v-expansion-panels v-model="panel2" :readonly="true" :flat="true" class="tw-mt-5 md:tw-mt-8" accordion>
                <v-expansion-panel>
                  <v-expansion-panel-header :hide-actions="true" color="primary1" class="tw-text-white">Benefits</v-expansion-panel-header>
                  <v-expansion-panel-content class="tw-w-full tw-mt-3 md:tw-mt-5">
                    <third-party-benefits />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div class="tw-w-full tw-mt-3">
              <what-is-third-party />
            </div>
          </div>
          <div class="tw-w-full md:tw-w-5/12 tw-px-2 md:tw-px-8 tw-py-4 tw-flex tw-flex-wrap tw-content-between ">
            <div class="tw-w-full tw-flex tw-flex-wrap">
              <h3 class="c-blue-text title-font tw-text-xl md:tw-text-1xl tw-px-3">Premium Calculator</h3>
              <div class="tw-w-full tw-mt-5 md:tw-mt-6">
                <div class="tw-w-full tw-flex">
                  <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Basic premium</p>
                  <p class="c-gray-text tw-text-left">Ksh. {{ (thirdAmount - (levy(thirdAmount) + pchf(thirdAmount) + 40)) | formatNum }}</p>
                </div>
                <div class="tw-w-full tw-flex">
                  <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Levies</p>
                  <p class="c-gray-text">Ksh. {{ levy(thirdAmount) + pchf(thirdAmount) + 40 | formatNum }}</p>
                </div>
              </div>
            </div>
            <div class="tw-w-full tw-mt-3 md:tw-mt-6">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Annual Premium</h4>
              <h2 class="c-light-blue-text title-font tw-text-3xl md:tw-text-5xl">Ksh. {{ thirdAmount | formatNum }}</h2>
              <v-card-actions class="tw-w-1/2 tw-mt-2">
                <v-btn block large
                       id="buyThird"
                       color="secondary"
                       class="my-3 "
                       @click="buyThirdParty"
                >
                  Buy Now
                </v-btn>
              </v-card-actions>
              <div v-if="emailQuote" class="tw-w-full tw-flex tw-justify-end">
                <email-quotation :quote-id="quote.quote.quoteId" :cover-type-id="106" />
              </div>
            </div>
          </div>
        </div>
     </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import helpers from '@/utils/helpers';
import axios from 'axios';
import validations from '@/utils/validations';
import Benefits from '@/components/shared/Benefits';
import { mapGetters } from 'vuex';
import ThirdPartyBenefits from '@/components/shared/ThirdPartyBenefits';
import EmailQuotation from '@/components/rfq/EmailQuotation';
import WhatIsComprehensive from '@/components/rfq/WhatIsComprehensive';
import WhatIsThirdParty from '@/components/rfq/WhatIsThirdParty';
import BenefitsDescription from '@/components/shared/BenefitsDescription';
import {
  FB_BUY_COMPREHENSIVE,
  FB_BUY_THIRD_PARTY,
  MINIMUM_COMP_PREMIUM,
  MINIMUM_EXCESS_PROTECTOR_PREMIUM,
} from '@/utils/const';

export default {
  name: 'QuoteSummary',
  components: {
    BenefitsDescription,
    WhatIsThirdParty,
    WhatIsComprehensive,
    EmailQuotation,
    ThirdPartyBenefits,
    Benefits,
  },
  props: ['quote'],
  data() {
    return {
      panel: [0],
      panel2: 0,
      isLoading: false,
      coverTypes: [],
      compAmount: this.quote.quote.covertypes.find((id) => id.covertypeId === 101) !== undefined ? this.quote.quote.covertypes.find((id) => id.covertypeId === 101).riskPremDto.totalPremium : 0,
      thirdAmount: this.quote.quote.covertypes.find((id) => id.covertypeId === 106).riskPremDto.totalPremium,
      addBenefits: [],
      beneficiaries: 0,
      ...validations,
      updatingAmount: false,
      benefits: [],
      emailQuote: true,
      travelEmbedMin: 1,
      travelEmbedMax: 6,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    comprehensive() {
      return this.quote.quote.covertypes.find((id) => id.covertypeId === 101);
    },
    thirdParty() {
      return this.quote.quote.covertypes.find((id) => id.covertypeId === 106);
    },
    compBenefits() {
      return this.coverTypes.find((c) => c.code === 101);
    },
    thirdBenefits() {
      return this.coverTypes.find((c) => c.code === 106);
    },
    isTravelEmbed() {
      return this.addBenefits.length > 0 ? !!this.addBenefits.find((e) => e.sectionCode === 234) : false;
    },
  },
  watch: {
    addBenefits(val) {
      if (val.length > 0) {
        if (val.filter((e) => e.sectionCode === 234).length === 0) {
          this.updateBenefits(val);
        } else if (val.find((e) => e.sectionCode === 234) && (this.beneficiaries >= 1 && this.beneficiaries <= 6)) {
          const values = [];
          let index;
          this.addBenefits.forEach((v) => {
            values.push(v);
          });
          const original = this.compBenefits.benefits.find((x) => x.sectCode === 234);
          if (original) {
            // eslint-disable-next-line prefer-const
            index = values.findIndex((x) => x.sectionCode === 234);
            // eslint-disable-next-line no-param-reassign
            values[index] = { noOfBeneficiaries: this.beneficiaries, sectionCode: original.sectCode, sectionName: original.sectDesc };
            this.updateBenefits(values);
          }
        }
      } else {
        this.updateBenefits([]);
      }
    },
    beneficiaries(val) {
      let index;
      const values = [];
      this.addBenefits.forEach((v) => {
        values.push(v);
      });
      if (values.find((e) => e.sectionCode === 234) && (this.beneficiaries >= 1 && this.beneficiaries <= 6)) {
        const original = this.compBenefits.benefits.find((x) => x.sectCode === 234);
        if (original) {
          index = values.findIndex((x) => x.sectionCode === 234);
          // eslint-disable-next-line no-param-reassign
          values[index] = { noOfBeneficiaries: val, sectionCode: original.sectCode, sectionName: original.sectDesc };
          this.updateBenefits(values);
        }
      }
    },
  },
  mounted() {
    this.getCoverTypes().then((cover) => {
      this.coverTypes = cover;
      this.isLoading = true;
    });
  },
  methods: {
    updateBenefits(body) {
      this.updatingAmount = true;
      const data = {
        benefits: body,
        riskId: this.comprehensive.riskId,
      };
      axios.post('/customer/quotation/benefit/change', data)
        .then((response) => {
          this.compAmount = response.data.totalPremium;
          this.benefits = response.data.benefits;
          this.updatingAmount = false;
        });
    },
    getCoverTypes() {
      // return axios.get(`/customer/gis/products/${this.quote.prodId}/covertypes`).then((response) => Promise.all(response.data.object.map(async (el) => {
      return axios.get('/customer/gis/products/70/covertypes').then((response) => Promise.all(response.data.object.map(async (el) => {
        const o = { ...el };
        // eslint-disable-next-line no-shadow
        o.benefits = await axios.get(`/customer/gis/products/70/covertypes/${el.code}/chargeablebenefits`).then((benefit) => benefit.data.object);
        // o.benefits = await axios.get(`/customer/gis/products/${this.quote.prodId}/covertypes/${el.code}/chargeablebenefits`).then((benefit) => benefit.data.object);
        // eslint-disable-next-line no-shadow
        // disable this for now
        // o.productFeatures = await axios.get(`/customer/quotation/productFeatures/${this.quote.prodId}/${el.code}`).then((feature) => feature.data.data[0]);
        return o;
      })));
    },
    levy(amount) {
      return Math.round((0.2 / 100) * amount);
    },
    pchf(amount) {
      return Math.ceil((0.25 / 100) * amount);
    },
    basicPremium(comprehensive) {
      const amount = Math.ceil(parseInt(comprehensive.car.valueOfCar, 10) * (comprehensive.rateApplied / 100));
      if (amount < MINIMUM_COMP_PREMIUM) {
        return MINIMUM_COMP_PREMIUM;
      }
      return amount;
    },
    benefitsInAmount(benefit, premium) {
      const amount = Math.ceil((benefit.rate / benefit.divFactor) * premium);
      if (benefit.sectCode === 1614 && amount < MINIMUM_EXCESS_PROTECTOR_PREMIUM) {
        return MINIMUM_EXCESS_PROTECTOR_PREMIUM;
      }
      return amount;
    },
    sumBenefits() {
      if (this.benefits.length > 0) {
        return this.benefits.reduce((sum, current) => sum + current.benefitPremium, 0);
      }
      return 0;
    },
    buyComprehensive() {
      this.$analytics.logEvent(FB_BUY_COMPREHENSIVE, { quoteId: this.quote.quote.quoteId, riskId: this.comprehensive.riskId });
      if (this.isAuthenticated) {
        this.$router.push({ name: 'BuyCover', query: { q: this.quote.quote.quoteId, b: this.comprehensive.riskId } });
      } else {
        this.$router.push({ name: 'SignIn', query: { q: this.quote.quote.quoteId, b: this.comprehensive.riskId } });
      }
    },
    buyThirdParty() {
      this.$analytics.logEvent(FB_BUY_THIRD_PARTY, { quoteId: this.quote.quote.quoteId, riskId: this.thirdParty.riskId });
      if (this.isAuthenticated) {
        this.$router.push({ name: 'BuyCover', query: { q: this.quote.quote.quoteId, b: this.thirdParty.riskId } });
      } else {
        this.$router.push({ name: 'SignIn', query: { q: this.quote.quote.quoteId, b: this.thirdParty.riskId } });
      }
    },
    selectedOther(code) {
      if (code === 85) {
        return !!this.addBenefits.find((e) => e.sectionCode === 18422);
      }
      if (code === 18422) {
        return !!this.addBenefits.find((e) => e.sectionCode === 85);
      }
      return false;
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>

<style scoped>
.tw-bg-no-repeat {
  background-size: 350px;
}
.slide-enter, .slide-leave-to{
  transform: scaleY(0);
}
input[type=checkbox] {
  transform: scale(1.5);
  border: solid 2px; /* Safari */
}
</style>
